import React, { useEffect, useState } from 'react';
import { Container } from 'reactstrap';
import MobileDeviceKeyDetails from './components/MobileDeviceKeyDetails';
import PndApi from '../../../../utils/pnd/PndRestApi';
import SnackbarContent from '@mui/material/SnackbarContent';
import LinearProgress from '@mui/material/LinearProgress';
import SmartphoneIcon from '@mui/icons-material/Smartphone';
import ConfirmationDialog from 'src/shared/components/ConfirmationDialog';
import PndRestApi from '../../../../utils/pnd/PndRestApi';
import { showNotification, successNofication } from 'src/shared/components/Notification';
import { CLIENT_ADMIN, ERROR_MESSAGES, ITC_ADMIN_ROLE_ID, PAGE_TIMEOUT } from 'src/utils/pnd/PndConstants';
import { useSelector } from 'react-redux';
import { Box } from '@mui/material';
import PageHeader from 'src/shared/components/layout/PageHeader';

const MobileDeviceKeyDetailsIndex = () => {
  useEffect(() => {
    getAllDeviceDetails();
  }, [])

  const [reactTableData, setReactTableData] = useState([]);
  const [viewDetailPopup, setViewDetailPopup] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isNoRecordFound, setNoRecordFound] = useState(false);
  const [isDevId, setDevId] = useState(null);
  const [isRedirect, setIsRedirect] = useState(false);
  const orderPreferences = useSelector(state => state.orderPreferences);

  if (isRedirect) {
    window.location.reload();
  }

  const getAllDeviceDetails = async () => {
    try {
      setLoading(true);
      const response = await PndApi.GetAllDeviceDetails();
      if (response.status === 200 && response.data.status === 200) {
        setReactTableData({ tableRowsData: response.data.data });
      } else if (response?.data?.status && response?.data?.status === 204) {
        setNoRecordFound(true);
      }
    } catch (error) {
      console.log("getAllDeviceDetails -->", error);
      showNotification(
        "theme-light",
        "ltr",
        `SuccessCode: 500`,
        ERROR_MESSAGES.tryCatchError,
      );
    } finally {
      setLoading(false);
    }
  };

  const closeDialog = () => {
    setViewDetailPopup(false);
  };

  const handleSubmit = async () => {
    try {
      setLoading(true);
      const response = await PndRestApi.UpdateLicenceDetails(isDevId);
      if (response.status === 200 && response.data.status === 200) {
        successNofication(
          "theme-light",
          "ltr",
          `SuccessCode: ${response.data.status}`,
          `Message: License number canceled successfully.`,
        );
        setTimeout(() => {
          setIsRedirect(true);
        }, PAGE_TIMEOUT);
      } else {
        showNotification(
          "theme-light",
          "ltr",
          `SuccessCode: ${response.data.status}`,
          `Message:${response.data.message}`,
        );
      }
    } catch (error) {
      console.log("error", error);
      showNotification(
        "theme-light",
        "ltr",
        `SuccessCode: 500`,
        ERROR_MESSAGES.tryCatchError,
      );
    } finally {
      setLoading(false);
    }
  };

  const triggerCancel = (devId) => {
    if (devId) {
      setDevId(devId);
      setViewDetailPopup(true);
    }
  };

  const canCancelLicense = localStorage.getItem('uri') == ITC_ADMIN_ROLE_ID || 
    (localStorage.getItem('uri') == CLIENT_ADMIN && orderPreferences?.data?.licenseCancelEnabled);

  return (
    <Box sx={{ p: 3, backgroundColor: '#f8fafc', minHeight: '100vh' }}>
      <Container fluid style={{ maxWidth: '1400px' }}>
        <PageHeader
          icon={<SmartphoneIcon fontSize="large" />}
          title="Device License Details"
          subtitle="View and manage mobile device licenses, keys, and client mappings."
          gradient="linear-gradient(135deg, #475569 0%, #1e293b 100%)"
        />

        {loading && <LinearProgress sx={{ mb: 2, borderRadius: 2 }} />}

        <Box sx={{ position: 'relative' }}>
          {(reactTableData && reactTableData != null && reactTableData.tableRowsData != null) && !isNoRecordFound && (
            <MobileDeviceKeyDetails
              reactTableData={reactTableData}
              canCancelLicense={canCancelLicense}
              onCancelLicense={triggerCancel}
              isNoRecordFound={isNoRecordFound}
            />
          )}
          {isNoRecordFound && (
            <MobileDeviceKeyDetails
              isNoRecordFound={isNoRecordFound}
              canCancelLicense={canCancelLicense}
              onCancelLicense={triggerCancel}
            />
          )}
          {/* {isNoRecordFound && <SnackbarContent message={"No Record Found"} />} */}
        </Box>

        {viewDetailPopup && (
          <ConfirmationDialog
            open={viewDetailPopup}
            onClose={closeDialog}
            onConfirm={handleSubmit}
            title="Confirmation"
            message="Are you sure, Do you want to cancel the Device License?"
          />
        )}
      </Container>
    </Box>
  );
};

export default MobileDeviceKeyDetailsIndex;